var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 44,
    viewBox: "0 0 77 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3633_1031",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 77,
    height: 44
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.287354,
    y: 0.575195,
    width: 76.4972,
    height: 42.6961,
    rx: 6.98156,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3633_1031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.1422 22.6865L38.3989 11.1446L18.7351 41.4603L29.1417 72.3987L82.5489 53.6249L72.1422 22.6865Z",
    fill: "#E5D4FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7836 11.73L19.5238 26.9368L32.93 66.7926L76.1898 51.5858L62.7836 11.73Z",
    fill: "#F0F7FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0709 23.6921L34.3784 30.2629L34.9294 31.9009L53.6219 25.33L53.0709 23.6921Z",
    fill: "#4E1A95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9806 27.368L31.1407 37.5059L31.7835 39.4168L60.6234 29.2789L59.9806 27.368Z",
    fill: "#4E1A95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.817 32.828L32.9772 42.9658L33.6199 44.8767L62.4598 34.7389L61.817 32.828Z",
    fill: "#4E1A95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5488 53.6245L72.1421 22.6861L52.4783 53.0019L18.735 41.46L29.1416 72.3983L82.5488 53.6245Z",
    fill: "#9949FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8054 42.0821L82.5487 53.624L29.1416 72.3978L48.8054 42.0821Z",
    fill: "#4E1A95"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMail);
export default __webpack_public_path__ + "static/media/newMail.0126a515bb88064ed25e1e5506104f03.svg";
export { ForwardRef as ReactComponent };